module.exports = require('./helpers/bundle-url').getBundleURL('hOC9M') + "logo.c51670a8.svg";